import { Route } from "react-router-dom";

import { USER_TYPE } from "src/constants";
import { MY_PROFILE_ROUTES } from "src/pages/my-profile/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { MyProfile } from "./MyProfile.page";

/** Route tree for the my-profile module, mounted under `/my-profile`. */
export const myProfileRoutes = (
  <Route
    path={MY_PROFILE_ROUTES.root}
    element={<ProtectedRoute userType={[USER_TYPE.ADMIN, USER_TYPE.USER]} component={MyProfile} />}
  />
);
